import sxsStore from '../store/Store';
import { isClientAttachmentIdEqual } from 'owa-client-ids';
export default function isSxSDisplayed(store) {
    if (!store) {
        store = sxsStore;
    }
    return !!store.viewState.previewPane;
}
export function isSxSDisplayedForAttachment(id, store) {
    if (!store) {
        store = sxsStore;
    }
    return (isSxSDisplayed(store) && isClientAttachmentIdEqual(id, store.extendedViewState.attachmentId));
}
//# sourceMappingURL=isSxSDisplayed.js.map